export const dateRegEx =
  // eslint-disable-next-line no-control-regex
  /\d{2}\/\d{2}\/\d{4}/;

export const emailRegex =
  // eslint-disable-next-line no-control-regex
  /^(?:[A-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[A-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9]{2,}(?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])$/i;

export const passwordLengthRegex =
  // eslint-disable-next-line no-control-regex
  /.{8,}$/;

export const passwordUppercaseRegex =
  // eslint-disable-next-line no-control-regex
  /(?=.*[A-Z])/;

export const passwordLowercaseRegex =
  // eslint-disable-next-line no-control-regex
  /(?=.*[a-z])/;

export const passwordNumberRegex =
  // eslint-disable-next-line no-control-regex
  /(?=.*\d)/;

export const passwordSymbolRegex =
  // eslint-disable-next-line no-control-regex
  /(?=.*\W)/;

export const passwordRegEx =
  // eslint-disable-next-line no-control-regex
  /^(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9])(?=.*[\^$*.[\]{}()?"!@#%&/\\,><':;|_~`=+\- ])[A-Za-z0-9^$*.[\]{}()?"!@#%&/\\,><':;|_~`=+\- ]{8,256}$/;

export const nameRegEx =
  // eslint-disable-next-line no-control-regex
  /(.*[a-z]){2,}$/;

export const phoneNumberRegExUS =
  // eslint-disable-next-line no-control-regex
  /\d{3}-\d{3}-\d{4}/;

export const uuidRegEx =
  //eslint-disable-next-line no-control-regex
  /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/;

export const zipCodeRegExUs =
  // eslint-disable-next-line no-control-regex
  /^[0-9]{5}(?:-[0-9]{4})?$/;

export function isValidEmail(value: string) {
  return RegExp(emailRegex).test(value);
}

export function isValidConcreitEmail(value: string) {
  return RegExp(emailRegex).test(value) && value.split('@')[1] === 'concreit.com';
}

export function isValidPassword(value: string) {
  return RegExp(passwordRegEx).test(value);
}

export function isValidName(value: string) {
  return RegExp(nameRegEx).test(value);
}

export function isValidUSPhoneNumber(value: string) {
  return RegExp(phoneNumberRegExUS).test(value);
}

export function passwordContains8Characters(value: string | null) {
  if (value !== null) {
    return RegExp(passwordLengthRegex).test(value);
  }
}

export function passwordContainsUppercase(value: string | null) {
  if (value !== null) {
    return RegExp(passwordUppercaseRegex).test(value);
  }
}

export function passwordContainsLowerCase(value: string | null) {
  if (value !== null) {
    return RegExp(passwordLowercaseRegex).test(value);
  }
}

export function passwordContainsNumber(value: string | null) {
  if (value !== null) {
    return RegExp(passwordNumberRegex).test(value);
  }
}

export function passwordContainsSymbol(value: string | null) {
  if (value !== null) {
    return RegExp(passwordSymbolRegex).test(value);
  }
}

export const passwordValidations = [
  passwordContains8Characters,
  passwordContainsUppercase,
  passwordContainsLowerCase,
  passwordContainsNumber,
  passwordContainsSymbol,
];
